import * as React from 'react';
import { Button, FlexRow, FormCell, Grid } from 'ui-toolkit';
import { IRecordedMortgage } from '../classes/RecordedMortgage';
import getText from '../utils/getText';
import DateText from './fields/DateText';
import TimeText from './fields/TimeText';

interface IExistingRecordedMortgage {
  data: IRecordedMortgage;
  title: string;
  onEditClick: (title?: string) => void;
}

// tslint:disable-next-line:function-name
const RecordedMortgageBlock: React.FunctionComponent<IExistingRecordedMortgage> = (props) => {
  const onEditClick = () => {
    props.onEditClick(getText('recordedDeed.editNew'));
  };

  return (
    <Grid>
      <FlexRow justifyContent={'space-between'}>
        <h2>{props.title}</h2>
        <Button intent="secondary" onClick={onEditClick}>
          Edit
        </Button>
      </FlexRow>
      <Grid columnCount={4}>
        <FormCell label={'Recorded date'}>
          <DateText date={props.data.recorded_date} />
        </FormCell>
        <FormCell label={'Recorded time'}>
          <TimeText time={props.data.recorded_at} />
        </FormCell>
        <FormCell label={'Executed date'}>
          <DateText date={props.data.execution_date} />
        </FormCell>
      </Grid>
    </Grid>
  );
};

export default RecordedMortgageBlock;
